import React from 'react';
import FormROValue from '../../../../library/form/components/FormROValue1';

const DashGroupChoice = (props) => {
    const { formObject, rowKey } = props;
    return (
        <div className="uiRecordContainer">
            <div className="uiBar" styleFormula="{0}">
                <div className="uiInline uiH110" >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taskTitle" }} />
                </div>
            </div>
            <div className="uiBarInfo uiH110" >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taskSubTitle" }} />
            </div>
            <div className="uiDashPop">
            </div>
        </div>
    )
}

export default DashGroupChoice
